// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZqVoWWJtKQqGkxRzC2uw{margin:0 24px 24px 24px}.vfEe8z_b2dEURwNzyGcY{margin:0 24px 16px 24px}`, "",{"version":3,"sources":["webpack://./src/entities/Seat/ui/ManageSeats/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,uBAAA,CAEF,sBACE,uBAAA","sourcesContent":[".seatsInput {\n  margin: 0 24px 24px 24px;\n}\n.priceInfo {\n  margin: 0 24px 16px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"seatsInput": `ZqVoWWJtKQqGkxRzC2uw`,
	"priceInfo": `vfEe8z_b2dEURwNzyGcY`
};
export default ___CSS_LOADER_EXPORT___;
